import React from 'react';
import { AccountInfoProvider, MarketplaceSelectedList } from '@amzn/aac-marketplace-selector';
import { ICellRendererParams } from '@ag-grid-community/core';
import { StyledCellWrapper } from '@urc-ui/components/styles';
import { getFormattedLocale } from '@urc-ui/utils/app-utils';
import { Text } from '@amzn/storm-ui-v3';

export function CountryCell(props: ICellRendererParams) {
  const formattedLocale = getFormattedLocale();
  const marketplaceIds = props.value;

  if (!marketplaceIds || marketplaceIds.length === 0) {
    return (
      <StyledCellWrapper>
        <Text fontSize='small'>&#8212;</Text>
      </StyledCellWrapper>
    );
  }
  return (
    <StyledCellWrapper>
      <AccountInfoProvider>
        <MarketplaceSelectedList id={'marketPlaceIds-selectedList'} selected={marketplaceIds} language={formattedLocale} />
      </AccountInfoProvider>
    </StyledCellWrapper>
  );
}
